import $ from 'cash-dom'
import { Auth } from 'aws-amplify'
import { segment } from '../tracking/segment'

const stage = !window.Pura?.environment?.production
const clientId = stage
  ? '6n43s10do1victjnk4sg9j7sb4'
  : '4iekubat0jb5iljfbaalsiqf9j'

const hostedUiDomain = stage
  ? 'https://staging-pura.auth.us-east-1.amazoncognito.com'
  : 'https://auth.pura.co'

const shopifyLogout = stage
  ? 'https://staging-pura-scents.myshopify.com/account/logout'
  : 'https://pura.com/account/logout'

async function hubSignOut() {
  try {
    await Auth.signOut().catch(() => {})
    const keysToRemove = [
      'amplify-signin-with-hostedUI',
      'amplify-oauth-state',
      'amplify-oauth-pkce',
      'amplify-redirected-from-hosted-ui',
    ]

    for (const k of keysToRemove) {
      localStorage.removeItem(k)
      sessionStorage.removeItem(k)
    }

    segment.reset()
  } finally {
    const url = `${hostedUiDomain}/logout?client_id=${encodeURIComponent(
      clientId
    )}&logout_uri=${encodeURIComponent(shopifyLogout)}`
    location.href = url
  }
}

$('a[href="/account/logout"]').on('click', (event) => {
  event.preventDefault()

  hubSignOut()
})

export { hubSignOut }
